import { useQuery } from '@tanstack/react-query';
import { Fund } from '../types';

export const useFund = (fundId?: string) => {
  const { data, isLoading, refetch } = useQuery<Fund>({
    queryKey: ['funds', fundId],
    enabled: !!fundId,
  });

  return {
    fund: data,
    isLoading,
    refetch,
  };
};
